module.exports = __webpack_public_path__ + "isabelexelboemer.jpg?769497cd0c0a77fccca947b3134734ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/isabelexelboemer.jpg
// module id = 127
// module chunks = 0